import glamorous from 'glamorous'

export const StyledLogo = glamorous.svg({
  width: '242px',
  height: '53px',
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Logo/Logo.glamorous.tsx